import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["size", "color", "alignWithText", "aria-label", "id"];
// THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY.

import { useTheme } from 'foundations-theming/utils';
import { isCanvasTheme } from 'foundations-theming/utils';
import { useIconSize } from 'foundations-assets/icons/useIconSize';
import { StyledIcon } from 'foundations-assets/icons/StyledIcon';
import { getDataProps } from 'foundations-assets/icons/getDataProps';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const ExclamationIcon = _ref => {
  let {
      size: sizeProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      color: colorProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      alignWithText = false,
      'aria-label': ariaLabel,
      id
    } = _ref,
    restProps = _objectWithoutPropertiesLoose(_ref, _excluded);
  const theme = useTheme();
  const dataProps = getDataProps(restProps);
  const isCanvas = isCanvasTheme(theme);

  // Setting default values here
  const size = sizeProp !== null && sizeProp !== void 0 ? sizeProp : 'inherit';
  const color = colorProp !== null && colorProp !== void 0 ? colorProp : 'inherit';
  const sizeValue = useIconSize(size);
  const sizeCSSValue = sizeProp ? `${sizeValue} !important` : sizeValue; // Adds the `!important` flag to the `size` value if one is provided via props

  const colorValue = color === 'inherit' ? 'currentColor' : theme.color[color]; // inherit = currentColor = text color of the parent element
  const colorCSSValue = colorProp ? `${colorValue} !important` : colorValue; // Adds the `!important` flag to the `color` value if one is provided via props

  return /*#__PURE__*/_jsx(StyledIcon, Object.assign({}, dataProps, {
    $size: sizeCSSValue,
    $color: colorCSSValue,
    $alignWithText: alignWithText,
    "aria-label": ariaLabel,
    "aria-hidden": ariaLabel === undefined ? true : undefined,
    id: id,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    focusable: "false",
    "data-icon-name": "Exclamation",
    children: isCanvas ? /*#__PURE__*/_jsx(_Fragment, {
      children: /*#__PURE__*/_jsx("path", {
        d: "M19.74 26.26c0 2.07-1.67 3.74-3.74 3.74s-3.74-1.67-3.74-3.74 1.67-3.74 3.74-3.74 3.74 1.67 3.74 3.74M12.29 4.13A1.856 1.856 0 0 1 14.13 2h3.75c1.03 0 1.86.83 1.86 1.86 0 .09 0 .19-.02.28s-1.86 13.05-1.86 13.05c-.12.93-.9 1.63-1.85 1.63s-1.73-.71-1.85-1.63-1.88-13.07-1.88-13.07Z"
      })
    }) : /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsx("path", {
        d: "M15.57 20.71c-.63 0-1.14-.51-1.14-1.14V7a1.14 1.14 0 1 1 2.28 0v12.57c0 .63-.51 1.14-1.14 1.14"
      }), /*#__PURE__*/_jsx("circle", {
        cx: "15.57",
        cy: "24.71",
        r: ".57"
      }), /*#__PURE__*/_jsx("path", {
        d: "M15.57 26.43c-.94 0-1.71-.77-1.71-1.71s.77-1.71 1.71-1.71 1.71.77 1.71 1.71-.77 1.71-1.71 1.71m0-2.29a.57.57 0 1 0 0 1.14.57.57 0 0 0 0-1.14"
      })]
    })
  }));
};
ExclamationIcon.displayName = 'ExclamationIcon';